export default {
  enums: [
    { id: 'GOODSIMPORT' },
    { id: 'LP_INTRODUCE_OST' },
    { id: 'Promotion_Inform_Selfmade' },
    { id: 'LP_FTS_INTRODUCE' },
    { id: 'CROSSBORDER' },
  ],
};
